import { SxProps, TextField, TextFieldProps } from "@mui/material";
import { FC } from "react";

type Props = {} & TextFieldProps;

const Input: FC<Props> = (props) => {
  let sx: object | Function = {
    ...props.sx,

    "& .MuiFilledInput-root": {
      backgroundColor: "transparent",
      border: "1px solid rgb(217, 217, 217)",

      "&.Mui-focused": {
        borderColor: "rgb(22, 119, 255)",
      },

      "&::before": {
        display: "none",
      },

      "& svg": {
        color: "rgba(0, 0, 0, 0.54)",
      },

      "& .MuiInputBase-input": {
        height: "auto",
        paddingTop: 1,
        paddingLeft: "10px",
      },
    },
  };
  if (typeof props.sx === "function") {
    sx = props.sx;
  }

  return <TextField {...props} sx={sx as SxProps} />;
};

export default Input;
